module.exports = __webpack_public_path__ + "static/media/logo-blanco.9e7efd97.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-blanco.png
// module id = 432
// module chunks = 2